import { render, staticRenderFns } from "./PurchaseOrderDisplayView.vue?vue&type=template&id=946af9b6"
import script from "./PurchaseOrderDisplayView.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports